// Import Routes
import * as ROUTES from "../routes";

import CRYPTO_MANAGER from '@/modules/crypto/views/manager';
import CRYPTO_TRANS from '@/modules/crypto/views/transactions';
import CRYPTO_TRADES from '@/modules/crypto/views/trades';

const routes = [
    {
        path: ROUTES.CRYPTO_MANAGER,
        name: "cryptoManager",
        component: CRYPTO_MANAGER,
        meta: {
            title: "Crypto Manager",
            layout: "private",
            requiresAuth: true,
            nav: 'Crypto',
            permissions: ['can_view_crypto_manager']
        }
    },
    {
        path: ROUTES.CRYPTO_transactionS,
        name: "cryptotransactions",
        component: CRYPTO_TRANS,
        meta: {
            title: "crypto transactions",
            layout: "private",
            requiresAuth: true,
            nav: 'Crypto',
            permissions: ['can_view_crypto_transaction']
        }
    },
    {
        path: ROUTES.CRYPTO_TRADES,
        name: "cryptoTrades",
        component: CRYPTO_TRADES,
        meta: {
            title: "Crypto Trades",
            layout: "private",
            requiresAuth: true,
            nav: 'Crypto',
            permissions: ['can_view_crypto_trade']
        }
    }
]

export default routes;